import { Link } from 'react-router-dom';
import { Video } from '@/mocks/videos';
import { categories } from '@/mocks/categories';

interface VideoCardProps {
  video: Video;
}

export default function VideoCard({ video }: VideoCardProps) {
  const category = categories.find((c) => c.slug === video.category);

  return (
    <Link
      to={`/article/${video.id}`}
      className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
    >
      <div className="relative w-full aspect-video overflow-hidden">
        <img
          src={video.thumbnail}
          alt={video.title}
          title={`${video.title} - 国产自拍视频精选`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute bottom-2 right-2 bg-foreground-900/75 text-background-50 text-xs px-2 py-0.5 rounded-md">
          {video.duration}
        </div>
        {category && (
          <span className="absolute top-2 left-2 bg-primary-500/90 text-background-50 text-xs px-2 py-0.5 rounded-md">
            {category.name}
          </span>
        )}
      </div>
      <div className="p-4">
        <h3 className="text-sm font-semibold text-foreground-900 line-clamp-2 group-hover:text-primary-600 transition-colors leading-snug">
          {video.title}
        </h3>
        <p className="mt-1.5 text-xs text-foreground-500 line-clamp-2 leading-relaxed">{video.description}</p>
        <div className="mt-3 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <img
              src={video.authorAvatar}
              alt={video.author}
              className="w-5 h-5 rounded-full object-cover"
            />
            <span className="text-xs text-foreground-600">{video.author}</span>
          </div>
          <div className="flex items-center gap-3 text-xs text-foreground-500">
            <span className="flex items-center gap-1">
              <i className="ri-eye-line"></i>
              {video.views >= 10000 ? `${(video.views / 10000).toFixed(1)}万` : video.views}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-heart-line"></i>
              {video.likes >= 10000 ? `${(video.likes / 10000).toFixed(1)}万` : video.likes}
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
}